import React from "react";
import { Col, Row } from "react-bootstrap";

const RealPropertyOwned = ({ data }) => {
  return (
    <div>
      <section className="view-data">
        <Row className="main-view-email pt-3">
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Property Description:</strong>
              {data?.property_description || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Location:</strong>
              {data?.location || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Current Fair market Value:</strong>
              {data?.current_fair_market_value || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Loan Balance:</strong>
              {data?.loan_balance || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Amount of monthly payment:</strong>
              {data?.amount_of_monthly_payment || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Amount of your equity:</strong>
              {data?.amount_of_your_equity || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Name of Lender:</strong>
              {data?.name_of_lender || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Address:</strong>
              {data?.address || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Account Number:</strong>
              {data?.account_no || "--"}
            </div>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default RealPropertyOwned;
